import { graphql } from "react-relay";

export const QUERY_FRAGMENT = graphql`
	fragment manualOrdersTable_QueryFragment on Query
	@refetchable(queryName: "manualOrdersTable_Refetch")
	@argumentDefinitions(
		first: { type: "Int" }
		after: { type: "String" }
		accountId: { type: "ID!" }
	) {
		Admin {
			Billing {
				GetManualOrdersForAccount(first: $first, after: $after, accountId: $accountId)
					@connection(key: "manualOrdersTable_GetManualOrdersForAccount") {
					__id
					pageInfo {
						endCursor
						hasPreviousPage
						hasNextPage
						startCursor
					}
					edges {
						node {
							...manualOrdersTable_ManualOrderFragment
						}
					}
				}
			}
		}
	}
`;

export const MANUAL_ORDER_FRAGMENT = graphql`
	fragment manualOrdersTable_ManualOrderFragment on ManualOrder @inline {
		id
		invoiceNumber
		salesPerson {
			name
		}
		createdAt
		productSelection {
			product {
				id
				title
			}
			price {
				grossPrice
				netPrice
				taxRatePercentage
			}
		}
		discountSelection {
			id
			code
			createdAt
			numUsages
		}
	}
`;

export const DELETE_MANUAL_ORDER_MUTATION = graphql`
	mutation manualOrdersTable_DeleteManualOrderMutation(
		$input: DeleteManualOrderInput!
		$connections: [ID!]!
	) {
		Admin {
			Billing {
				DeleteManualOrder(input: $input) {
					deletedIds @deleteEdge(connections: $connections)
				}
			}
		}
	}
`;
